/*
 * Entry point of the application.
 * Only platform bootstrapping code should be here.
 * For app-specific initialization, use `app/app.component.ts`.
 */

import '@angular/localize/init'; // Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from '@app/app.module';
import { environment } from '@env/environment';
import { sentryConfig } from '@app/core/sentry-config';

if (environment.production && !environment.debug) {
  enableProdMode();
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

bootstrap().catch(err => {
  console.error(err);

  if (!Sentry.isInitialized()) {
    Sentry.init(sentryConfig);
  }
  Sentry.withScope(scope => {
    scope.setTag('data.source', 'main.ts');
    Sentry.setUser({ ip_address: '{{auto}}' });
    Sentry.captureException(err);
  });
});
